export const COOKIE_VAELG_SELV_SELECTED_CHANNELS =
    'COOKIE_VAELG_SELV_SELECTED_CHANNELS';
export const COOKIE_VAELG_SELV_SELECTED_PACKAGE =
    'COOKIE_VAELG_SELV_SELECTED_PACKAGE';
